import { useState, useEffect } from "react";
import { InputRadioOp1Props } from "../InputRadioOp1/InputRadioOp1.type";
import { Input } from "../../core/Input";
import BasicDatePicker from "../DatePicker/DatePicker";

export default function InputRadioCM({
    fieldName,
    label,
    register,
    error,
    required,
    readOnly,
    getValues,
    setValue,
    control
}: InputRadioOp1Props) {
    const [isYes, setIsYes] = useState(() => {
        const val = getValues?.(fieldName);
        return val === "Si" || val === true;
    });

    useEffect(() => {
        const val = getValues?.(fieldName);
        setIsYes(val === "Si" || val === true);
    }, [getValues, fieldName]);

    return (
        <div className="flex flex-col gap-4 justify-start align-middle">
            <div className="w-full flex flex-col align-middle md:flex-row md:justify-between">
                <label className="mb-3">{label}</label>
                <div className="mr-3">
                    <label className="sm:mx-3">
                        <input
                            type="radio"
                            disabled={readOnly}
                            className="mx-1 sm:mx-3 text-red-500"
                            {...register(fieldName, { required })}
                            value="Si"
                            onClick={() => setIsYes(true)}
                            checked={getValues?.(fieldName) === "Si" || getValues?.(fieldName) === true}
                        />
                        Si
                    </label>
                    <label className="sm:mx-3">
                        <input
                            type="radio"
                            disabled={readOnly}
                            className="mx-1 sm:mx-3 text-red-500"
                            {...register(fieldName, { required })}
                            value="No"
                            onClick={() => {
                                setIsYes(false);
                                setValue("professional_cm", null);
                                setValue("professional_license_cm", null);
                                setValue("cm_days", null);
                                setValue("cm_date", null);
                            }}
                            checked={getValues?.(fieldName) === "No" || getValues?.(fieldName) === false}
                        />
                        No
                    </label>
                </div>
            </div>

            {isYes && (
                <div className="flex flex-col gap-2 justify-start align-middle">
                    <Input
                        type="text"
                        fieldName="professional_cm"
                        label="Apellido y Nombre del profesional del CM"
                        register={register}
                        style={{ width: "300px" }}
                    />
                    <Input
                        type="text"
                        fieldName="professional_license_cm"
                        label="Matrícula CM"
                        register={register}
                        style={{ width: "300px" }}
                    />
                    <BasicDatePicker
                        fieldName="cm_date"
                        label="Fecha CM"
                        minDate={3}
                        maxDate={0}
                        control={control}

                    />
                    <Input
                        type="text"
                        fieldName="cm_days"
                        label="Días otorgados"
                        register={register}
                        style={{ width: "300px" }}
                    />
                </div>
            )}

            {/* ERROR */}
            {error?.message && (
                <span className="text-red-500">{error.message}</span>
            )}
            {error?.type === "required" && (
                <span className="text-red-500">Campo obligatorio*</span>
            )}
        </div>
    );
}
